import React, { useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import getCookie from 'utils/getCookie'
import { requestUserLogout } from 'api/user'

export const AuthContext = React.createContext(false)

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(getCookie('jwtfe'))

  const logout = () => {
    requestUserLogout()
    setIsAuthenticated(false)
    document.cookie = "jwt=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; Secure; SameSite=Strict"
    document.cookie = "jwtfe=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; Secure; SameSite=Strict"
    globalThis.dispatchEvent(new CustomEvent('userLoggedOut'))
  }

  const contextValue = useMemo(() => ({
    isAuthenticated,
    setIsAuthenticated,
    logout
  }), [isAuthenticated])

  return (
    <AuthContext.Provider
      value={contextValue}
    >
      {children}
    </AuthContext.Provider>
  )
}

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired
}

export default AuthProvider
